import React from "react";
import ReactDOM from "react-dom";
import ContextManager from "./ContextManager";
import MainFile from "./MainFile";
ReactDOM.render(<ContextManager><MainFile/></ContextManager>,document.getElementById("root"));